import axios from "axios";
import {API_BASE_URL, BASE_URL} from "./consts";

export const getAllStorage = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${BASE_URL}/api/storage`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting storages:", error);
		throw error;
	}
};

export const getDrivers = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/drivers`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting drivers:", error);
		throw error;
	}
};

export const getSborshiks = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/sborshiks`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting sborshiks:", error);
		throw error;
	}
};

export const getMagazins = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/magazins`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting magazins:", error);
		throw error;
	}
};

export const createShipment = async (data) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `POST`,
			url: `${API_BASE_URL}/gotoviy/shipments`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);

		return response.data;
	} catch (error) {
		console.error("Error creating shipment:", error);
		throw error;
	}
};

export const editShipment = async (id, data) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `PATCH`,
			url: `${API_BASE_URL}/gotoviy/shipments/${id}`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error editing shipment:", error);
		throw error;
	}
};

export const getShipments = async (page = 1) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/shipments?page=${page}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting shipments:", error);
		throw error;
	}
};

export const getShipmentFurnitures = async (id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/shipments/${id}/furnitures`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting furnitures of shipments:", error);
		throw error;
	}
};

export const deleteShipment = async (id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `DELETE`,
			url: `${API_BASE_URL}/gotoviy/shipments/${id}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error deleting shipment", error);
		throw error;
	}
};
